import type { IMarkSpec, ISymbolMarkSpec } from '@visactor/vchart';

export type IBarMarkerSpec = IMarkSpec<ISymbolMarkSpec>;
